import { useState } from "react";
import { Form } from "react-bootstrap";
import useValidator from "../../hooks/useValidator";
import ReCAPTCHA from "react-google-recaptcha";
import {
  encodeBase64,
  encryptDecrypt,
} from "../../modules/helpers/validations";
import sha256 from "sha256";
import { postUpdate } from "../../services/serviceVivetuseguro";
import Portal from "../../modules/helpers/Portal";
import { TerminosyCondiciones } from "../../modules/helpers/TerminosyCondiciones";
import { AvisoDePrivacidad } from "../../modules/helpers/AvisoDePrivacidad";

const SidebarActivarCuentaPass = ({
  errorData,
  mensaje,
  recaptchaRef,
  setMensaje,
  setSpinner,
  setErrorData,
  formCode,
  setCount,
  urlApi,
  codRecaptcha,
  handleClose,
  setShowModalActivaSuccess,
  form,
  setObjUsuarioLogin,
}) => {
  const [mensajeErrorCheckbox, setMensajeErrorCheckbox] = useState("");
  const [ocultoPass, setOcultoPass] = useState(true);
  const [ocultoConfirmPass, setOcultoConfirmPass] = useState(true);
  const [formPass, setFormPass] = useState({
    id: "",
    code: "",
    password: "",
    passwordconfirm: "",
    tokenCaptcha: "",
  });

  const [terminos, setTerminos] = useState(false);
  const [privacidad, setPrivacidad] = useState(false);

  const handleChangePass = (e) => {
    document.getElementById("passwordconfirm").style.borderColor =
      "var(--bs-border-color)";
    document.getElementById("passwordconfirm").style.color =
      "var(--bs-offcanvas-color)";
    document.getElementById("password").style.borderColor =
      "var(--bs-border-color)";
    document.getElementById("password").style.color =
      "var(--bs-offcanvas-color)";
    setMensaje("");
    setFormPass({
      ...formPass,
      [e.target.name]: e.target.value,
    });
  };

  const { formValidador } = useValidator(formPass.password);

  const cambiarOcultoPass = () => {
    setOcultoPass(!ocultoPass);
  };

  const cambiarOcultoConfirmPass = () => {
    setOcultoConfirmPass(!ocultoConfirmPass);
  };

  const handleSubmitActivaCuenta = async (e) => {
    e.preventDefault();

    setMensajeErrorCheckbox("");

    let camposVacios = false;
    if (
      document.getElementById("check_terminos").checked === false ||
      document.getElementById("check_privacidad").checked === false
    ) {
      setMensajeErrorCheckbox("Para continuar, acepta los avisos legales");
      camposVacios = true;
    }

    if (formPass.password === "") {
      setMensaje("Este dato es necesario");
      document.getElementById("password").style.borderColor = "var(--rojo)";
      document.getElementById("password").style.color = "var(--rojo)";
      camposVacios = true;
    }

    if (formPass.passwordconfirm === "") {
      setMensaje("Este dato es necesario");
      document.getElementById("passwordconfirm").style.borderColor =
        "var(--rojo)";
      document.getElementById("passwordconfirm").style.color = "var(--rojo)";
      camposVacios = true;
    }

    if (formPass.password === formPass.passwordconfirm) {
      if (camposVacios) return;

      const token = await recaptchaRef.current.executeAsync();
      recaptchaRef.current.reset();
      let tokenUpdate = await recaptchaRef.current.executeAsync();
      recaptchaRef.current.reset();
      let tokenLogin = await recaptchaRef.current.executeAsync();
      recaptchaRef.current.reset();

      if (!token) {
        setMensaje("Captcha inválido, actualizar web");
        return;
      }

      setSpinner(true);

      let pattern =
        /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!,%,&,@,#,$,^,*,?,_,~,.,(,),/,-]).{7,15}/;
      if (!pattern.test(formPass.passwordconfirm)) {
        setMensaje(
          "La nueva contraseña debe tener al entre 8 y 16 caracteres, al menos un dígito, al menos una minúscula y al menos una mayúscula."
        );
        setErrorData(true);
        setSpinner(false);
        document.getElementById("passwordconfirm").style.borderColor =
          "var(--rojo)";
        document.getElementById("passwordconfirm").style.color = "var(--rojo)";
        // console.log('err 1')
        return;
      }

      if (!pattern.test(formPass.password)) {
        setMensaje(
          "La nueva contraseña debe tener al entre 8 y 16 caracteres, al menos un dígito, al menos una minúscula y al menos una mayúscula."
        );
        setErrorData(true);
        setSpinner(false);
        document.getElementById("password").style.borderColor = "var(--rojo)";
        document.getElementById("password").style.color = "var(--rojo)";
        // console.log('err 2')
        return;
      }

      try {
        let saltPassword = btoa(
          encryptDecrypt(
            sha256(formPass.password),
            tokenUpdate.substring(tokenUpdate.length - 10, tokenUpdate.length)
          )
        );

        let datosUpdate = {
          fono: "0", //rpta.user.fono ? rpta.user.fono : "",
          idusuario: formCode.id, //rpta.user.idusuario,
          email: form.identificacion, //rpta.user.email ? rpta.user.email : "",
          clave: saltPassword,
          tokenCaptcha: tokenUpdate,
        };

        postUpdate(datosUpdate, urlApi).then(async (res) => {
          if (res.Codigo === 1 || res.Codigo === 2) {
            setMensaje(res.Mensaje);
            setSpinner(false);
            document.getElementById("passwordconfirm").style.borderColor =
              "var(--rojo)";
            document.getElementById("passwordconfirm").style.color =
              "var(--rojo)";
            document.getElementById("password").style.borderColor =
              "var(--rojo)";
            document.getElementById("password").style.color = "var(--rojo)";
          } else if (res.Codigo === 0) {
            setMensaje("");

            let objUsuario = {
              usuario: encodeBase64(form.identificacion),
              password: encodeBase64(
                encryptDecrypt(
                  sha256(formPass.password),
                  tokenLogin.substring(
                    tokenLogin.length - 10,
                    tokenLogin.length
                  )
                )
              ),
              sitioPassword: "9B9CB6631B27AA1DF47DB351B497004810015B09",
              sitioUsuario: "CARDIF",
              deviceInfo: "",
              tokenCaptcha: tokenLogin,
            };

            setSpinner(false);
            setObjUsuarioLogin(objUsuario);
            setShowModalActivaSuccess(true);
            window.dataLayer.push({
              event: `SBK_LSA_REGISTROEXITOSO`,
              action: `BTN_ACTIVATUCUENTA`,
            });
            handleClose();
          }
        });
      } catch (err) {
        document.getElementById("passwordconfirm").style.borderColor =
          "var(--rojo)";
        document.getElementById("passwordconfirm").style.color = "var(--rojo)";
        document.getElementById("password").style.borderColor = "var(--rojo)";
        document.getElementById("password").style.color = "var(--rojo)";
        setMensaje(err);
        setErrorData(true);
        setSpinner(false);
      }
    } else {
      document.getElementById("passwordconfirm").style.borderColor =
        "var(--rojo)";
      document.getElementById("passwordconfirm").style.color = "var(--rojo)";
      document.getElementById("password").style.borderColor = "var(--rojo)";
      document.getElementById("password").style.color = "var(--rojo)";
      setErrorData(true);
      setMensaje("La contraseña no coincide. Por favor, revísala");
    }
  };

  return (
    <>
      {terminos && (
        <Portal
          show={terminos}
          setShow={setTerminos}
          terminos={TerminosyCondiciones}
        />
      )}
      {privacidad && (
        <Portal
          show={privacidad}
          setShow={setPrivacidad}
          terminos={AvisoDePrivacidad}
        />
      )}
      <div className="body__login">
        <h2>Crea una contraseña</h2>
        <p>Sólo falta crear una contraseña segura</p>
        <Form
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault();
          }}
          className="form__modal"
        >
          <div className="row justify-content-center">
            <label className="label__text">
              <b>Contraseña</b>
            </label>
            <div className="col-12 login__pass">
              <input
                type={`${ocultoPass ? "password" : "text"}`}
                className="form-control border-input "
                id="password"
                name="password"
                placeholder="Ingresa tu contraseña"
                autoComplete="off"
                value={formPass.password}
                onChange={handleChangePass}
              />
              {ocultoPass ? (
                <i
                  onClick={cambiarOcultoPass}
                  className="fa-solid fa-eye-slash pass__icon"
                ></i>
              ) : (
                <i
                  onClick={cambiarOcultoPass}
                  className="fa-solid fa-eye pass__icon"
                ></i>
              )}
            </div>
            {mensaje !== "" && (
              <div className="texto__error__campo">
                <p>{mensaje}</p>
              </div>
            )}
            <label className="label__text">
              <b>Contraseña</b>
            </label>
            <div className="col-12 login__pass">
              <input
                type={`${ocultoConfirmPass ? "password" : "text"}`}
                className="form-control border-input "
                id="passwordconfirm"
                name="passwordconfirm"
                placeholder="Confirma tu contraseña"
                autoComplete="off"
                value={formPass.passwordconfirm}
                onChange={handleChangePass}
              />
              {ocultoConfirmPass ? (
                <i
                  onClick={cambiarOcultoConfirmPass}
                  className="fa-solid fa-eye-slash pass__icon"
                ></i>
              ) : (
                <i
                  onClick={cambiarOcultoConfirmPass}
                  className="fa-solid fa-eye pass__icon"
                ></i>
              )}
            </div>
            {mensaje !== "" && (
              <div className="texto__error__campo">
                <p>{mensaje}</p>
              </div>
            )}

            {formValidador()}

            <div className="div__checkboxes">
              <input type="checkbox" id="check_terminos" />
              <label className="label__checkbox">
                <p>
                  He leído y estoy de acuerdo con los{" "}
                  <span
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => setTerminos(true)}
                  >
                    términos y condiciones
                  </span>
                </p>
              </label>
              <br />
              <input type="checkbox" id="check_privacidad" />
              <label className="label__checkbox">
                <p>
                  He leído y estoy de acuerdo con el{" "}
                  <span
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => setPrivacidad(true)}
                  >
                    aviso de privacidad
                  </span>
                </p>
              </label>
            </div>
            {mensajeErrorCheckbox !== "" && (
              <div
                className="texto__error__campo"
                style={{ marginTop: "1rem", marginLeft: "2.5rem" }}
              >
                <p>{mensajeErrorCheckbox}</p>
              </div>
            )}

            <div className="col-12 mt-5 text-center">
              <button className="btn__azul" onClick={handleSubmitActivaCuenta}>
                Finalizar
              </button>
              <ReCAPTCHA
                ref={recaptchaRef}
                size="invisible"
                sitekey={codRecaptcha}
              />
            </div>
          </div>
        </Form>
      </div>
    </>
  );
};

export default SidebarActivarCuentaPass;
